export const removeDetailPanes = () => {

    //const leftPane = document.getElementById('leftpane');
    const unitsList = document.getElementById('unitslist');
    while (unitsList.hasChildNodes()) {
        unitsList.removeChild(unitsList.lastChild);
    }
    //leftPane.style.display = "none";

    const middlepane = document.getElementById('middlepane');
    while (middlepane.hasChildNodes()) {
        middlepane.removeChild(middlepane.lastChild);
    }
    //middlepane.style.display = "none";

    const rightpane = document.getElementById('rightpane');
    while (rightpane.hasChildNodes()) {
        rightpane.removeChild(rightpane.lastChild);
    }
    //rightpane.style.display = "none";

    const detailsPane = document.getElementById('detailspane');
    detailsPane.style.display = 'none';
}